import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PermissionGuard } from '@app/core';
import {
    AlertsComponent,
    ApiKeysComponent,
    EnvironmentAdminsComponent,
    EnvironmentsComponent,
    FileTransferComponent,
    FileTransfersAlertsComponent,
    FileTransfersApiKeysComponent,
    FileTransfersComponent,
    FileTransfersRenamingParametersComponent,
    GlobalAdminsComponent,
    HomeComponent,
    LocalAgentsCommandsComponent,
    LocalAgentsComponent,
    LocalAgentsExecutionTriggersComponent,
    LocalAgentsMaintenancesComponent,
    LogsComponent,
    PgpKeysComponent,
    ProfileComponent,
    RemotePlatformsComponent
} from '@app/features';
import { MainLayoutComponent } from '@app/shared';
import { MsalGuard } from '@azure/msal-angular';
import { BrowserUtils } from '@azure/msal-browser';

const routes: Routes = [
    {
        path: '',
        component: MainLayoutComponent,
        canActivate: [MsalGuard],
        children: [
            { path: 'admins', component: GlobalAdminsComponent, canActivate: [MsalGuard, PermissionGuard], data: { permissionName: 'canManageGlobalAdministrators' } },
            { path: 'environments', component: EnvironmentsComponent, canActivate: [MsalGuard, PermissionGuard], data: { permissionName: 'canManageEnvironments' } },
            { path: ':id/profile', component: ProfileComponent, canActivate: [MsalGuard, PermissionGuard], data: { isEnvironment: true, permissionName: 'canManageEnvironmentSettings' } },
            { path: ':id/admins', component: EnvironmentAdminsComponent, canActivate: [MsalGuard, PermissionGuard], data: { isEnvironment: true, permissionName: 'canManageEnvironmentSettings' } },
            { path: ':id/alerts', component: AlertsComponent, canActivate: [MsalGuard, PermissionGuard], data: { isEnvironment: true, permissionName: 'canManageEnvironmentSettings' } },
            { path: ':id/api-keys', component: ApiKeysComponent, canActivate: [MsalGuard, PermissionGuard], data: { isEnvironment: true, permissionName: 'canManageEnvironmentSettings' } },
            { path: ':id/local-agents', component: LocalAgentsComponent, canActivate: [MsalGuard, PermissionGuard], data: { isEnvironment: true, permissionName: 'canManageLocalAgents' } },
            { path: ':id/local-agents-commands', component: LocalAgentsCommandsComponent, canActivate: [MsalGuard, PermissionGuard], data: { isEnvironment: true, permissionName: 'canManageLocalAgents' } },
            { path: ':id/local-agents-execution-triggers', component: LocalAgentsExecutionTriggersComponent, canActivate: [MsalGuard, PermissionGuard], data: { isEnvironment: true, permissionName: 'canManageLocalAgents' } },
            { path: ':id/local-agents-maintenances', component: LocalAgentsMaintenancesComponent, canActivate: [MsalGuard, PermissionGuard], data: { isEnvironment: true, permissionName: 'canManageLocalAgents' } },
            { path: ':id/remote-platforms', component: RemotePlatformsComponent, canActivate: [MsalGuard, PermissionGuard], data: { isEnvironment: true, permissionName: 'canManageRemotePlatforms' } },
            { path: ':id/pgp-keys', component: PgpKeysComponent, canActivate: [MsalGuard, PermissionGuard], data: { isEnvironment: true, permissionName: 'canManagePgpKeys' } },
            { path: ':id/logs', component: LogsComponent, canActivate: [MsalGuard, PermissionGuard], data: { isEnvironment: true, permissionName: 'canAccessLogs' } },
            { path: ':id/file-transfers', component: FileTransfersComponent, canActivate: [MsalGuard, PermissionGuard], data: { isEnvironment: true, permissionName: 'canManageFileTransfers' } },
            { path: ':id/file-transfers/:ft', component: FileTransferComponent, canActivate: [MsalGuard, PermissionGuard], data: { isEnvironment: true, permissionName: 'canManageFileTransfers' } },
            { path: ':id/file-transfers-alerts', component: FileTransfersAlertsComponent, canActivate: [MsalGuard, PermissionGuard], data: { isEnvironment: true, permissionName: 'canManageFileTransfers' } },
            { path: ':id/file-transfers-api-keys', component: FileTransfersApiKeysComponent, canActivate: [MsalGuard, PermissionGuard], data: { isEnvironment: true, permissionName: 'canManageFileTransfers' } },
            { path: ':id/file-transfers-renaming-parameters', component: FileTransfersRenamingParametersComponent, canActivate: [MsalGuard, PermissionGuard], data: { isEnvironment: true, permissionName: 'canManageFileTransfers' } },
            { path: '**', component: HomeComponent, pathMatch: 'full' },
        ],
    },
    { path: '**', redirectTo: '' }
];
const isIframe = window !== window.parent && !window.opener;

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
    onSameUrlNavigation: 'reload',
    initialNavigation: !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup() ? 'enabledNonBlocking' : 'disabled'
}),
    ],
    exports: [
        RouterModule,
    ],
    declarations: [],
})
export class AppRoutingModule {
}
